export default __webpack_public_path__ + "static/media/Logo.68dc7478.png";